
import { parseISO, format } from 'date-fns'
import { ptBR } from 'date-fns/locale'
export default {
  props: {
    loadingBtn: Boolean,
    items: {
      type: Object,
      default: () => {},
    },
    actionConfirm: {
      type: Function,
      default: () => {},
    },
  },
  computed: {
    formattedDateTime() {
      const datetime = parseISO(this.items.horario)
      return format(datetime, "EEEE, d 'de' MMMM 'de' yyyy", { locale: ptBR })
    },
  },
}
